import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardProgressBarComponent } from './card-progress-bar.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [CardProgressBarComponent],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [CardProgressBarComponent]
})
export class CardProgressBarModule { }
